module.exports = __webpack_public_path__ + "static/media/iconBillsF.21f67433.svg";